import { product_tag } from '../../../../features/ProductList/constant';
import { ProductTagBase, ProductTagBaseProps } from './ProductTagBase';
import { SoldOutTag } from './tags/SoldOutTag';
import { UpcomingTag } from './tags/UpcomingTag';
import { QuantityLimitedTag } from './tags/QuantityLimitedTag';
import { PeriodLimitedTag } from './tags/PeriodLimitedTag';
import { NftTag } from './tags/NftTag';
import { RealtimeTag } from './tags/RealtimeTag';
import { isDate, isNumber } from '@fxts/core';
import { ProductTagType } from '../../../../features/ProductList/type';
import { WatcherCountTag } from './tags/WatcherCountTag';

/**
 * @deprecated 곧 없어질 예정
 */
export class ProductTagFactory {
  static readonly type = product_tag;

  static create(type: 'sold_out', props: ProductTagBaseProps): SoldOutTag;

  static create(type: 'realtime', value: Date, props: ProductTagBaseProps): RealtimeTag;

  static create(type: 'upcoming', value: Date, props: ProductTagBaseProps): UpcomingTag;

  static create(type: 'period_limited', value: Date, props: ProductTagBaseProps): PeriodLimitedTag;

  static create(type: 'watcher_count', value: number, props: ProductTagBaseProps): WatcherCountTag;

  static create(type: 'quantity_limited', value: number, props: ProductTagBaseProps): QuantityLimitedTag;

  static create(type: 'nft', value: number | Date, props: ProductTagBaseProps): NftTag;

  static create(
    type: ProductTagType,
    value: Date | number | ProductTagBaseProps,
    props?: ProductTagBaseProps,
  ): ProductTagBase {
    if (!isDate(value) && !isNumber(value)) {
      const props = value;
      if (type === product_tag.sold_out) {
        return new SoldOutTag({
          ...props,
          now_timestamp: Date.now(),
          value: undefined,
        });
      }
    } else if (props) {
      if (type === product_tag.upcoming && isDate(value)) {
        return new UpcomingTag({
          ...props,
          now_timestamp: Date.now(),
          value,
        });
      } else if (type === product_tag.period_limited && isDate(value)) {
        return new PeriodLimitedTag({
          ...props,
          now_timestamp: Date.now(),
          value,
        });
      } else if (type === product_tag.realtime && isDate(value)) {
        return new RealtimeTag({
          ...props,
          now_timestamp: Date.now(),
          value,
        });
      } else if (type === product_tag.quantity_limited && isNumber(value) && value > 0) {
        return new QuantityLimitedTag({
          ...props,
          now_timestamp: Date.now(),
          value,
        });
      } else if (type === product_tag.watcher_count && isNumber(value)) {
        return new WatcherCountTag({
          ...props,
          now_timestamp: Date.now(),
          value,
        });
      } else if (type === product_tag.nft && (isNumber(value) || isDate(value))) {
        return new NftTag({
          ...props,
          now_timestamp: Date.now(),
          value,
        });
      }
    }

    throw new TypeError(`[ProductTagFactory] type: ${type}, value: ${value}`);
  }
}
